import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";

// Firebase Configuration
const firebaseConfig = {
    apiKey: "AIzaSyBhDy3JEIvD0HsYDvcrIV2kYJD5oxJmF0M",
    authDomain: "lechatbotwebsite.firebaseapp.com",
    projectId: "lechatbotwebsite",
    storageBucket: "lechatbotwebsite.firebasestorage.app",
    messagingSenderId: "586866677092",
    appId: "1:586866677092:web:f97988ca84b37c5fbc1671",
    measurementId: "G-EJDKJB4CC5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
const analytics = getAnalytics(app);

// Export services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export { analytics, logEvent };

export default app;


